<script>
  import { _ } from "./i18n.js";
  import { onMount, onDestroy } from "svelte";
  import { f7, List, ListItem, Button, Preloader } from "framework7-svelte";
  import { getSecuredFirestore } from "./Firestore.js";
  import { checkImage } from "./Utils.js";

  let users;

  onMount(async () => {
    load();
  });

  let snapshotlistener;
  onDestroy(async () => {
    snapshotlistener && snapshotlistener();
  });

  function load() {
    getSecuredFirestore().then(function(firestore) {
      snapshotlistener = firestore
        .collection("users")
        .orderBy("name")
        .onSnapshot(
          function(querySnapshot) {
            const u = [];
            querySnapshot.forEach(doc => {
              u.push({
                id: doc.id,
                name: doc.get("name"),
                profilePhoto: doc.get("profilePhoto"),
                orderCount: doc.get("orderCount") || 0
              });
            });
            users = u;
          },
          function(err) {
            console.log(err);
            users = -1;
            f7.dialog.alert($_("users.error"));
          }
        );
    });
  }
</script>

<div style="height: 100%">
  {#if !users}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Preloader />
    </div>
  {:else if users == -1}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Button fill round large on:click={() => ((users = null), load())}>
        {$_('order.reload')}
        <span style="margin-left: 8px" class="icon icon-loop" />
      </Button>
    </div>
  {:else if users}
    <List style="margin-top: 0px">
      {#each users as user}
        <ListItem
          link={'/Order/All/' + user.id + (user.name ? '/' + user.name : '')}
          title={user.name}
          after={user.orderCount}
          style="margin-top: 5px; margin-bottom: 5px">

          <span slot="content-start">
            {#if user.profilePhoto}
              {#await checkImage(user.profilePhoto) then status}
                {#if status}
                  <img
                    style="max-width: 40px; border-radius: 50%; margin-right:
                    10px"
                    alt="User Profile"
                    src={user.profilePhoto} />
                {:else}
                  <span
                    style="font-size: 2.5rem; color: rgb(0, 122, 255);
                    margin-right: 10px"
                    class="icon icon-profile" />
                {/if}
              {/await}
            {:else if users}
              <span
                style="font-size: 2.5rem; color: rgb(0, 122, 255); margin-right:
                10px"
                class="icon icon-profile" />
            {/if}
          </span>
        </ListItem>
      {/each}
    </List>
  {/if}
</div>
